module.exports = __webpack_public_path__ + "static/media/harmony_project.dc2cb1a3.md";